export default function rgb (r, g, b) {
  return 'rgb(' + r + ', ' + g + ', ' + b + ')'
}
